import React from 'react';
import { connect } from 'react-redux';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import * as campaignActions from '../campaign.actions';
import { getCurrentCampaign } from '../campaign.selectors';

import { ContentBlock } from '../../pages/components';
import SalesBoostForm from './SalesBoostForm';
import { Localize } from '../../../locale/localization';
import Dialog from '../../common/components/Dialog';

const constraints = {
  scoreModifier: {
    numericality: {
      greaterThan: 1,
      notValid: `^${Localize('form.sales-boost.score-modifier.error')}`,
      notGreaterThan: `^${Localize('form.sales-boost.score-modifier.error')}`,
    }
  },
};

const baseFormData = {
  scoreModifier: 0,
};

class SalesBoostBlock extends BaseFormContainer {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: Object.assign({}, baseFormData),
      boostActivated: false,
      dialogOpen: false,
    };
  }

  componentWillMount = () => {
    const {
      getCurrentCampaign
    } = this.props;

    getCurrentCampaign().then(() => {
      const { currentCampaign } = this.props;
      const {
        _id,
        scoreModifier,
        boostActivated,
      } = currentCampaign;

      this.setState({
        _id,
        boostActivated,
        formData: {
          scoreModifier,
        },
      }, this.validate);
    });
  }
  
  getConstraints = () => constraints;

  doSubmit = (formData) => {
    if(this.state.boostActivated) {
      this.confirmSubmit();
      return;
    }
    this.setState({
      dialogOpen: true,
    });
  }

  cancelSubmit = (event) => {
    this.setState({
      dialogOpen: false,
      isSubmitting: false,
    });
  }

  confirmSubmit = (event) => {
    const { updateCampaign } = this.props;
    const {
      _id,
      boostActivated,
      formData,
    } = this.state;
    
    updateCampaign({
      _id,
      boostActivated: !boostActivated,
      ...formData,
    }).then(() => {
      const { currentCampaign } = this.props;
      this.setState({
        isSubmitting: false,
        dialogOpen: false,
        boostActivated: currentCampaign.boostActivated,
      });
    });
  }

  render() {
    return (
      <ContentBlock title="Myyntibuusti">
        <SalesBoostForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}  
          boostActivated={this.state.boostActivated}
          scoreModifier={this.state.formData.scoreModifier}
        />

        <Dialog
          open={this.state.dialogOpen}
          title="Myyntibuusti"
          cancelLabel="Peruuta"
          confirmLabel="Kyllä"
          onCancel={this.cancelSubmit}
          onConfirm={this.confirmSubmit}
        >
          <p>Kaikki myyntibuustin aikana kertyvät pisteet tulevat {this.state.formData.scoreModifier}-kertaisina. Käynnistetäänkö myyntibuusti?</p>
        </Dialog>

      </ContentBlock>
    );
  }
};

const mapStateToProps = (state, { cancelPath }) => {
  const currentCampaign = getCurrentCampaign(state);
  //TODO
  return {
    currentCampaign,
    cancelPath,
  };
};

const ConnectedSalesBoostBlock = connect(
  mapStateToProps,
  Object.assign({}, campaignActions),
)(SalesBoostBlock);

export default ConnectedSalesBoostBlock;


// WEBPACK FOOTER //
// ./src/modules/campaign/components/SalesBoostBlock.js